<template>
  <div>
    <Header :title="title" :pageName="pageName"/>
    <div class="home-content" v-if="showContent">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <div style="height: 100vh" v-if="showWarn">
      <EmptyTips :tipsList="['非乘务员或安全员', '请确认身份！']" isWarn/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Home/Header'
import EmptyTips from '@/components/common/EmptyTips'

export default {
  name: 'Home',
  components: {
    Header,
    EmptyTips,
  },
  data() {
    return {
      title: '机上销售',
      showContent: false,
      showWarn: false,
      pageName: 'Home'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      localStorage.setItem('is_supplier', this.$route.query.ticket ? '0' : '1') // 0 非供应商，1 供应商
      // 防止刷新vuex数据丢失
      this.$store.commit('setUserInfo', JSON.parse(localStorage.getItem('sele_user_info')))
      this.$EventBus.$on('setTitle', (value) => {
        this.title = value
      })
      this.$EventBus.$on('setPageName', (value) => {
        this.pageName = value
      })
      this.setUserInfo()
    },
    setUserInfo() {
      // url不携带ticket不走解析接口
      if (!this.$route.query.ticket) {
        this.showContent = true
        return
      }
      // this.$api.get(`/api-auth/login/new/getSt?username=yangfang`).then((ticket1) => {
      let ticket = this.$route.query.ticket
      this.login(ticket)
      // })
    },
    // 解析 ticket
    login(ticket) {
      if (ticket && ticket !== localStorage.getItem('ticket')) {
        // 判断是新 ticket 则重新解析
        let url = `/api-auth/login/new/mobile?ticket=${ticket}`

        this.$api.post(url).then((res) => {
          if (res.code === '0000') {
            // 解析成功 缓存用户信息及tickct
            localStorage.setItem('sele_user_info', JSON.stringify(res.data))
            this.$store.commit('setUserInfo', res.data)
            localStorage.setItem('ticket', ticket)
            this.showContent = true
          } else if (res.code === '8101') {
            this.showWarn = true
          } else {
            // 解析失败，跳转至登陆页面
            window.location.href = `https://sso.hnair.net/login?appid=fitnet-crew&servise=${window.location.host}`
          }
        })
      } else {
        this.showContent = true
      }
    },
  },
}
</script>
<style lang="less" scoped>
.home-content {
  height: calc(100vh - 100px);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue